import { render, staticRenderFns } from "./ExchangeOrders.vue?vue&type=template&id=bc260abe&scoped=true"
import script from "./ExchangeOrders.vue?vue&type=script&lang=js"
export * from "./ExchangeOrders.vue?vue&type=script&lang=js"
import style0 from "./ExchangeOrders.vue?vue&type=style&index=0&id=bc260abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc260abe",
  null
  
)

export default component.exports